var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.44414 0.280157C8.84169 0.663517 8.8532 1.29658 8.46984 1.69414L3.35348 7L19 7C19.5523 7 20 7.44772 20 8C20 8.55229 19.5523 9 19 9L3.35348 9L8.46984 14.3059C8.8532 14.7034 8.84169 15.3365 8.44414 15.7198C8.04658 16.1032 7.41352 16.0917 7.03016 15.6941L0.280156 8.69414C-0.0933852 8.30676 -0.0933852 7.69324 0.280156 7.30587L7.03016 0.305865C7.41352 -0.0916936 8.04658 -0.103204 8.44414 0.280157Z",
    fill: "var(--grey-500)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.baad518ce6c9e136bca859e9062c1fa6.svg";
export { ForwardRef as ReactComponent };